import { DASHBOARD_CARD_PADDING } from '@/src/utils/constants'
import { Box } from '@chakra-ui/react'
import type { BoxProps } from '@chakra-ui/react'
import type { FC } from 'react'

type DashboardCardProps = BoxProps
export const DashboardCard: FC<DashboardCardProps> = ({ children, ...rest }) => {
  return (
    <Box
      backgroundColor='white'
      borderColor={'border'}
      borderWidth={'1px'}
      borderRadius={'8px'}
      boxShadow='0px 10px 12px -3px rgba(0, 0, 0, 0.02), 0px 4px 2px -2px rgba(0, 0, 0, 0.02)'
      padding={DASHBOARD_CARD_PADDING}
      {...rest}
    >
      {children}
    </Box>
  )
}
